import { render, staticRenderFns } from "./NewFolderCard.vue?vue&type=template&id=f92835d0&"
import script from "./NewFolderCard.vue?vue&type=script&lang=js&"
export * from "./NewFolderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports